import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-4 mb-2 fw-bold" }
const _hoisted_2 = { class: "mt-3 fs-12 text-gray" }
const _hoisted_3 = { class: "menu-filters" }
const _hoisted_4 = { class: "mt-3 fs-12 text-gray" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "ml-3" }
const _hoisted_7 = {
  key: 0,
  class: "menu-filters ml-auto"
}
const _hoisted_8 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_9 = { class: "p-field-radiobutton" }
const _hoisted_10 = { for: "DeviceIconsVisibilityAtTouch" }
const _hoisted_11 = { class: "p-field-radiobutton" }
const _hoisted_12 = { for: "DeviceIconsVisibilityAlways" }
const _hoisted_13 = { class: "mt-3 d-flex align-items-center" }
const _hoisted_14 = { class: "ml-3" }
const _hoisted_15 = { class: "mt-3 fs-12 text-gray" }
const _hoisted_16 = { class: "fs-14" }
const _hoisted_17 = { class: "fs-12 text-right text-gray mt-2" }
const _hoisted_18 = { class: "mt-3 d-flex align-items-center" }
const _hoisted_19 = { class: "ml-3" }
const _hoisted_20 = { class: "mt-3 fs-12 text-gray" }
const _hoisted_21 = { class: "p-field-radiobutton" }
const _hoisted_22 = { for: "DeviceLedModalityOn" }
const _hoisted_23 = { class: "p-field-radiobutton" }
const _hoisted_24 = { for: "DeviceLedModalityOnDuringUpdate" }
const _hoisted_25 = { class: "p-field-radiobutton" }
const _hoisted_26 = { for: "DeviceLedModalityOff" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_Divider = _resolveComponent("Divider")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Slider = _resolveComponent("Slider")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("AppResource.Settings")), 1),
    (_ctx.device.settingsVisibility.hasBrightness)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.BrightnessUpper")), 1),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_SelectButton, {
              onChange: _ctx.updateDeviceSettings,
              modelValue: _ctx.device.deviceBrightness,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.device.deviceBrightness = $event)),
              options: [
                    {
                        label: 'Min',
                        value: _ctx.DeviceBrightness.Min,
                    },
                    {
                        label: 'Max',
                        value: _ctx.DeviceBrightness.Max,
                    },
                ],
              dataKey: "value",
              optionValue: "value",
              optionLabel: "label",
              class: "menu-filters__buttons",
              disabled: !_ctx.plantDeviceSettingsEditEnabled
            }, null, 8, ["onChange", "modelValue", "options", "disabled"])
          ]),
          _createVNode(_component_Divider)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.device.settingsVisibility.hasProximity)
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("AppResource.ProximityUpper")), 1),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_InputSwitch, {
              onChange: _ctx.updateDeviceSettings,
              modelValue: _ctx.device.isProximityEnabled,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.device.isProximityEnabled = $event)),
              disabled: !_ctx.plantDeviceSettingsEditEnabled
            }, null, 8, ["onChange", "modelValue", "disabled"]),
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("AppResource.EnableDisableProximity")), 1),
            (_ctx.device.isProximityEnabled)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode(_component_SelectButton, {
                    onChange: _ctx.updateDeviceSettings,
                    modelValue: _ctx.device.deviceProximity,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.device.deviceProximity = $event)),
                    options: [
                        {
                            label: 'Min',
                            value: _ctx.DeviceProximity.Min,
                        },
                        {
                            label: 'Med',
                            value: _ctx.DeviceProximity.Med,
                        },
                        {
                            label: 'Max',
                            value: _ctx.DeviceProximity.Max,
                        },
                    ],
                    dataKey: "value",
                    optionValue: "value",
                    optionLabel: "label",
                    class: "menu-filters__buttons mx-0",
                    disabled: !_ctx.plantDeviceSettingsEditEnabled
                  }, null, 8, ["onChange", "modelValue", "options", "disabled"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.device.isProximityEnabled)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_RadioButton, {
                    name: "deviceIconsVisibility",
                    onChange: _ctx.updateDeviceSettings,
                    id: "DeviceIconsVisibilityAtTouch",
                    value: _ctx.DeviceIconsVisibility.AtTouch,
                    modelValue: _ctx.device.deviceIconsVisibility,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.device.deviceIconsVisibility = $event)),
                    disabled: !_ctx.plantDeviceSettingsEditEnabled
                  }, null, 8, ["onChange", "value", "modelValue", "disabled"]),
                  _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("AppResource.IconsShownAtTouch")), 1)
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_RadioButton, {
                    name: "deviceIconsVisibility",
                    onChange: _ctx.updateDeviceSettings,
                    id: "DeviceIconsVisibilityAtAlways",
                    value: _ctx.DeviceIconsVisibility.Always,
                    modelValue: _ctx.device.deviceIconsVisibility,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.device.deviceIconsVisibility = $event)),
                    disabled: !_ctx.plantDeviceSettingsEditEnabled
                  }, null, 8, ["onChange", "value", "modelValue", "disabled"]),
                  _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("AppResource.IconsAlwaysVisible")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_Divider)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.device.settingsVisibility.hasStandby)
      ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_InputSwitch, {
              onChange: _ctx.updateDeviceSettings,
              modelValue: _ctx.device.showLedsInStandby,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.device.showLedsInStandby = $event)),
              disabled: !_ctx.plantDeviceSettingsEditEnabled
            }, null, 8, ["onChange", "modelValue", "disabled"]),
            _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("AppResource.ShowLedsInStandby")), 1)
          ]),
          _createVNode(_component_Divider)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.device.settingsVisibility.hasLedIntensity)
      ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
          _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("AppResource.LedParametersUpper")), 1),
          _createVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("AppResource.LedIntensity")), 1),
          _createVNode(_component_Slider, {
            step: 10,
            orientation: "horizontal",
            modelValue: _ctx.device.ledIntensity,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.device.ledIntensity = $event)),
            onChange: _ctx.updateDeviceSettings,
            disabled: !_ctx.plantDeviceSettingsEditEnabled
          }, null, 8, ["modelValue", "onChange", "disabled"]),
          _createVNode("div", _hoisted_17, _toDisplayString(_ctx.device.ledIntensity) + " % ", 1)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.device.settingsVisibility.hasRefreshFeedback)
      ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
          _createVNode("div", _hoisted_18, [
            _createVNode(_component_InputSwitch, {
              onChange: _ctx.updateDeviceSettings,
              modelValue: _ctx.device.hasRefresherFeedback,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.device.hasRefresherFeedback = $event)),
              disabled: !_ctx.plantDeviceSettingsEditEnabled
            }, null, 8, ["onChange", "modelValue", "disabled"]),
            _createVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("AppResource.RefresherFeedbackEnabled")), 1)
          ]),
          _createVNode(_component_Divider)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.device.settingsVisibility.hasLedModality)
      ? (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
          _createVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("AppResource.LedModalityUpper")), 1),
          _createVNode("div", null, [
            _createVNode("div", _hoisted_21, [
              _createVNode(_component_RadioButton, {
                id: "DeviceLedModalityOn",
                name: "deviceIconsVisibility",
                value: _ctx.DeviceLedModality.On,
                modelValue: _ctx.device.ledModality,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.device.ledModality = $event)),
                onChange: _ctx.updateDeviceSettings,
                disabled: !_ctx.plantDeviceSettingsEditEnabled
              }, null, 8, ["value", "modelValue", "onChange", "disabled"]),
              _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("AppResource.LedModalityAlwaysOn")), 1)
            ]),
            _createVNode("div", _hoisted_23, [
              _createVNode(_component_RadioButton, {
                name: "deviceIconsVisibility",
                modelValue: _ctx.device.ledModality,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.device.ledModality = $event)),
                onChange: _ctx.updateDeviceSettings,
                id: "DeviceLedModalityOnDuringUpdate",
                value: _ctx.DeviceLedModality.OnDuringUpdate,
                disabled: !_ctx.plantDeviceSettingsEditEnabled
              }, null, 8, ["modelValue", "onChange", "value", "disabled"]),
              _createVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("AppResource.LedModalityOnUpdate")), 1)
            ]),
            _createVNode("div", _hoisted_25, [
              _createVNode(_component_RadioButton, {
                id: "DeviceLedModalityOff",
                name: "deviceIconsVisibility",
                value: _ctx.DeviceLedModality.Off,
                onChange: _ctx.updateDeviceSettings,
                modelValue: _ctx.device.ledModality,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.device.ledModality = $event)),
                disabled: !_ctx.plantDeviceSettingsEditEnabled
              }, null, 8, ["value", "onChange", "modelValue", "disabled"]),
              _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("AppResource.LedModalityAlwaysOff")), 1)
            ])
          ]),
          _createVNode(_component_Divider)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}